import BINUS from '../../assets/images/logo/BINUS.png';
import KGS from '../../assets/images/logo/KGS.png';

let educationTimeline = [
    {
        id: 1,
        title: "Master's Degree Computer Science",
        location: "Bina Nusantara University",
        date: "August 2023 - July 2025",
        gpa: "3.84/4.00",
        icon: "school",
        description: "Pursuing advanced studies with a concentration in Data and Machine Learning. This program deepens my knowledge in areas such as Big Data, and Artificial Intelligence and supports my thesis work titled 'A Personalized e-Commerce Recommender System with Non-Negative Matrix Factorization and Clustering Approaches'.",
        logo: BINUS,
    },
    {
        id: 2,
        title: "Bachelor's Degree Computer Science",
        location: "Bina Nusantara University",
        date: "September 2020 - March 2023",
        gpa: "3.69/4.00",
        icon: "school",
        description: "Completed my undergraduate studies with a solid foundation in web development and software engineering. Worked at FAVE Solution and involved in real-world software projects — creating websites and applications tailored for clients across Indonesia. This experience shaped my practical understanding of software development and client-centered product delivery.",
        logo: BINUS,
    },
    {
        id: 3,
        title: "High School Diploma",
        location: "Kanaan Global School",
        date: "July 2017 - July 2020",
        gpa: "3rd Honors",
        icon: "school",
        description: "Completed high school with a strong foundation in STEM subjects and a keen interest in technology. Participated in various extracurriculars such as Robotics and Computer Club, as well as sports like Badminton and Futsal. This period laid the groundwork for my future in computer science and software development.",
        logo: KGS,
    },
]

export default educationTimeline